const MessageError = ({ message }) => {
  return (
    <>
      <span
        style={{ fontSize: '90%' }}
        className="label-inputs-required text-danger py-0 px-2"
        // * parameter code: ERR_MSG_7
      >
        {message}
      </span>
      <br />
    </>
  );
};
export default MessageError;
